import { Paper, Stack } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

function GeneralFallbackComponent() {
  return (
    <Paper className="h-full w-full">
      <TextFallbackComponent />
    </Paper>
  );
}

function TextFallbackComponent() {
  const { t } = useTranslation();
  return (
    <Stack className="font-ds-headline-md h-full items-center justify-center">
      <p>{t("general.componentError")}</p>
    </Stack>
  );
}

export const GeneralErrorBoundary = ({ children, resetKeys = [] }) => {
  return (
    <ErrorBoundary FallbackComponent={GeneralFallbackComponent} resetKeys={resetKeys}>
      {children}
    </ErrorBoundary>
  );
};

export const EmptyErrorBoundary = ({ children, resetKeys }) => {
  return <ErrorBoundary resetKeys={resetKeys}>{children}</ErrorBoundary>;
};

export const TextErrorBoundary = ({ children }) => {
  return <ErrorBoundary FallbackComponent={TextFallbackComponent}>{children}</ErrorBoundary>;
};
